exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i);", ""]);

// module
exports.push([module.id, ".logo picture {\n  display: block; }\n\n.logo__sub-title {\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: 3px;\n  position: relative;\n  margin-top: 10px;\n  padding-top: 10px; }\n  .fixed .logo__sub-title {\n    display: none; }\n  @media only screen and (max-width: 767px) {\n    .logo__sub-title {\n      display: none; } }\n  .logo__sub-title:before {\n    content: '';\n    width: 100%;\n    height: 2px;\n    display: block;\n    position: absolute;\n    top: 0;\n    background: #ededed; }\n\n.logo__button {\n  text-align: left; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/containers/Header/components/Logo.scss
// module id = 365
// module chunks = 0